// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2KORI","addWidgetButton":"Header_addWidgetButton__1W_N7","dashboardTabs":"Header_dashboardTabs__29TdT","active":"Header_active__1nZU_"};